import React from 'react'
import PropTypes from 'prop-types'

class DeleteButton extends React.Component {
  animationInterval = null

  state = {
    animationTime: 0,
  }

  handleStartAnimation = (e) => {
    e.preventDefault()
    if (this.props.pending) return
    this.animationInterval = setInterval(() => {
      const { animationTime } = this.state
      if (animationTime + 50 >= 2000) {
        this.handleStopAnimation()
        this.props.callback()
        return
      }
      this.setState({ animationTime: animationTime + 50 })
    }, 50)
  }

  handleStopAnimation = (e) => {
    e && e.preventDefault()
    if (!this.animationInterval || this.props.pending) return
    clearInterval(this.animationInterval)
    this.animationInterval = null
    this.setState({ animationTime: 0 })
  }

  render() {
    const animationSize =
      this.state.animationTime === 0 ? 0 : Math.round((this.state.animationTime * 150) / 2000)

    return (
      <button
        type="button"
        className={`button button-primary is-block deletebtn ${
          this.props.pending ? 'is-loading' : ''
        }`}
        onMouseDownCapture={this.handleStartAnimation}
        onMouseUpCapture={this.handleStopAnimation}
        onMouseLeave={this.handleStopAnimation}
        style={this.props.style}
      >
        <span>{this.props.text}</span>
        <span>(hold for 2s)</span>
        <div style={{ right: 150 - animationSize }} />
      </button>
    )
  }
}

DeleteButton.propTypes = {
  text: PropTypes.string,
  pending: PropTypes.bool,
  callback: PropTypes.func,
  style: PropTypes.object,
}

export default DeleteButton
